export const generateFullAddress = (address: unknown) => {
  if (!address) return "";

  const order = ["street", "city", "state", "postal_code", "country"];

  return order.reduce((acc, key) => {
    const val = (typeof address === "object" && (address as Record<string, unknown>)?.[key]) || "";

    if ((key === "city" || key === "state") && (val as string).length) {
      acc += `${val}, `;
    } else {
      acc += `${val} `;
    }
    return acc;
  }, "");
};
